



























































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'ExcursionJf',
  // props: {
  // },
  components: {},
  setup: () => {
    return {};
  }
});
